import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Section = ({ id, className = "", children }) => (
  <section id={id} className={`relative px-5 py-24 sm:px-8 md:py-32 ${className}`}>
    <div className="mx-auto max-w-7xl">{children}</div>
  </section>
);

export const SectionHead = ({ label, title, sub }) => (
  <div className="mb-14 max-w-3xl md:mb-20">
    <Reveal>
      <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-volt">{label}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-5 font-display text-3xl font-black leading-[1.05] tracking-tighter sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mist sm:text-lg">{sub}</p>
      </Reveal>
    )}
  </div>
);
